import React from "react";
import { useQuery } from "@apollo/client/react";

import InternalWorkOrderModal from "src/views/shopping/Cart/SimpleCheckout/internalWorkOrders/InternalWorkOrderModal";
import { useProject } from "../ProjectProvider";
import { CREATE_INTERNAL_WORK_ORDER_MUTATION } from "src/constants/graphql/mutations";
import { USER_COMPANY_INTERNAL_WORK_ORDER_TYPES_QUERY } from "src/constants/graphql/queries";

export default function InternalWorkOrderProjectModal({ onClose, onSuccess }) {
  const { project } = useProject();
  const { data: { user = {} } = {} } = useQuery(USER_COMPANY_INTERNAL_WORK_ORDER_TYPES_QUERY);
  const internalWorkOrderTypes = user?.company?.internalWorkOrderTypes || [];

  const internalBillingTypes = [
    "Flat Rate/As Quoted (Internal Work Orders)",
    "Time and Materials (Blended Rate)",
    "Time and Materials (Itemized Rates)",
    "Not Applicable",
  ];

  return (
    <InternalWorkOrderModal
      query={CREATE_INTERNAL_WORK_ORDER_MUTATION}
      projectId={project.id}
      warehouse={project.warehouses.length === 1 ? project.warehouses[0]?.warehouseId : null}
      warehouses={project.warehouses}
      costCenters={project.costCenters}
      internalWorkOrderTypes={internalWorkOrderTypes}
      internalBillingTypes={internalBillingTypes}
      isProjectContext={true}
      onClose={onClose}
      onSuccess={() => {
        if (onSuccess) onSuccess();
      }}
    />
  );
}
